<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";
import {onMounted, watch} from "vue";

const { form } = defineProps({
    form: {
        type: Object,
        default: {}
    },
    southWest: {
        type: Boolean,
        default: false,
    }
})

watch(
    () => form.contactAnyTime,
    () => {
        form.contactTimeSchedule = null
    }
)
</script>

<template>
    <FormContainer title="Contacting you">
        <v-row>
            <v-col cols="12" tabindex="0">
                <p>Please let us know when you would prefer us to contact you</p>
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col>
                        <v-textarea
                            label="Preferred contact times"
                            aria-label="Preferred contact times"
                            persistent-hint
                            v-model="form.contactTimeSchedule"
                        >
                            <template v-slot:details>
                                <v-label
                                    text="We will do our very best to get back to you at a time that works for you and will let you know if for any reason we can’t."
                                    role="option"
                                    class="v-messages__message v-messages white-space-pre-wrap"
                                    tabindex="0"
                                />
                            </template>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-checkbox
                    v-model="form.termsAndConditions"
                    color="primary"
                    :error-messages="form.errors.termsAndConditions"
                    aria-required="true"
                >
                    <template v-slot:label>
                        <small>
                            I consent to my data being used as outlined in the <a class="se-hyperlink-bg" href="https://www.lafosteringse.org.uk/privacy-notices/" target="_blank">Privacy Policy <v-icon size="12">far fa-arrow-up-right-from-square</v-icon> </a>?*
                        </small>
                    </template>
                </v-checkbox>
                <v-checkbox
                    v-model="form.receiveOtherUpdates"
                    color="primary"
                >
                    <template v-slot:label>
                        <small>
                            Would you like to receive other updates from us?
                        </small>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>

</style>
